import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { PhoneCode } from './PhoneCode';
import { Lockout } from './Lockout';
//import { UnableToSignIn } from './UnableToSignIn';
import { LargeButton } from "./common/Buttons";
import { Modal } from "./common/Modal";
import { OneTouch } from './OneTouch';
import { AuthyToken } from './AuthyToken';
import CerDFLogo from "../images/DayforceLogo.png";
//import { Footer } from "./Footer";
import { t } from "./helper/ClientAppLocalizer";
import { EmailCode } from './EmailCode';

//these are the auth method claim values we're using from OIDC spec
const methodPush = 'push';
const methodOtp = 'otp';
const methodSms = 'sms';
const methodVoice = 'tel';
const methodEmail = 'email';

const allowedMethods = [methodPush, methodOtp, methodSms, methodVoice, methodEmail];


export class MFA extends Component {
    static displayName = MFA.name;
        
    constructor() {
        super();

        this.state = {
            error: false,
            oneTouchEnabled: false,
            verificationComplete: false,
            returnUrl: "",
            phoneNumbers: [],
            currentMethod: null,
            timeSent: null,
            allowRetry: true,
            loginSuccess: false,
            lockoutMessage: "",
            errorMessage: null,
            phoneState: null,
            showProviderUnavailableModal: false,
            providerUnavailableMessage: "",
            pushSent: false,
            EmailEnabled: false,
            EmailAddress: ""
        };

        this.pushElement = React.createRef();
        this.smsElement = React.createRef();
        this.voiceElement = React.createRef();
        this.emailElement = React.createRef();

        this.verificationComplete = this.verificationComplete.bind(this);
        this.doVerificationComplete = this.doVerificationComplete.bind(this);
        this.displayPhoneCode = this.displayPhoneCode.bind(this);

        this.changeVerificationMethod = this.changeVerificationMethod.bind(this);
        this.requestSent = this.requestSent.bind(this);
        this.allowRetry = this.allowRetry.bind(this);
    }

    componentDidMount() {
        fetch('/api/MFA/init', { method: 'post'})
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                }
                else {
                    throw new Error(results.statusText);
                }
            }).then(data => {
                if(allowedMethods.some(m => m === data.currentMethod)) {
                    data.timeSent = Date.now();
                    //if current method is in the init call it means we already sent it, if it is push let's note it
                    //to avoid a double push
                    //we should create a cypress test to validate a 2nd push is NOT sent as well
                    if (data.currentMethod === methodPush) {
                        if (data.providerUnavailableMessage) {
                            this.setState({
                                showProviderUnavailableModal: true,
                                providerUnavailableMessage: t(data.providerUnavailableMessage),
                                failClosedReturnUrl: data.providerUnavailableReturnUrl
                            });
                        }
                        else
                        {
                            this.setState({pushSent: true});
                        }
                    }
                }
                this.setState(data);
            }).catch(error => {
                //"Error initializing MFA"                
                this.setState({ error: true });
            });

    }

    requestSent(method) {
        this.setState({ timeSent: Date.now(), currentMethod: method});
    }

    displayPhoneCode(phoneId, method) {        
        let phoneState = this.state.phoneNumbers.filter(ph => ph.id === phoneId)[0];
        this.setState({ phoneState: phoneState, currentMethod: method });
    }

    changeVerificationMethod()
    {
        this.setState({ phoneState: null, currentMethod: null, errorMessage: null });
    }

    allowRetry(retryAllowed, errorMessage, returnUrl, newLockoutMessage) {
        if(!retryAllowed) {
            this.setState({ returnUrl: returnUrl });

            if (newLockoutMessage && newLockoutMessage.trim() !== "") {
                this.setState({ lockoutMessage: newLockoutMessage });
            }
        }

        this.setState({ allowRetry: retryAllowed, errorMessage: errorMessage });
    }

    verificationComplete(verificationResult) {
        if (verificationResult.providerUnavailable) {
            this.setState({
                showProviderUnavailableModal: true,
                providerUnavailableMessage: t(verificationResult.message),
                failClosedReturnUrl: verificationResult.returnUrl //if this is set then we're failing closed
            });
        }
        else {
            this.doVerificationComplete();
        }
    }

    doVerificationComplete() {
        // Clear error message
        this.setState({ errorMessage: null });

        if (this.state.failClosedReturnUrl) {
            window.location.href = this.state.failClosedReturnUrl;
        }

        //this post signs in the user and returns a redirect url if successful
        fetch('/Account/MFA', { method: 'post' })
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                } else {
                    throw new Error(results.statusText);
                }
            })
            .then(data => {
                window.location.href = data.returnUrl;
                this.setState({ loginSuccess: true });
            })
            .catch(error => {
                this.setState({ error: true });
            });
    }

    
    render() {
        const renderOneTouch = this.state.oneTouchEnabled;
        const renderEmail = this.state.emailEnabled;
        const hasError = this.state.error;

        //mapped from enums in API
        const unknownPhoneType = 0;
        const mobilePhoneType = 2;

        const voiceToTxt = t("MFA.VoiceCallTo");
        const textMsgToTxt = t("MFA.TextMessageTo"); 

        var displayComponent;
        if (!this.state.allowRetry) {
            displayComponent = <Lockout errorMessage={this.state.errorMessage} dayforceLoginUrl={this.state.returnUrl} 
                lockoutMessage={this.state.lockoutMessage} />;
        } else if (this.state.phoneState != null && this.state.phoneState !== undefined) {
            displayComponent = <PhoneCode method={this.state.currentMethod} phoneNumberId={this.state.phoneState.id}
                allowRetry={this.allowRetry}
                requestSent={this.requestSent}
                number={this.state.phoneState.number}
                verificationComplete={this.verificationComplete}
                changeVerificationMethod={this.changeVerificationMethod}
                lockoutMessage={this.state.lockoutMessage} />;
        } else if (this.state.currentMethod === methodPush) {
            displayComponent = <OneTouch method={this.state.currentMethod}
                pushSent={this.state.pushSent}
                allowRetry={this.allowRetry}
                verificationComplete={this.verificationComplete}
                changeVerificationMethod={this.changeVerificationMethod}
                ref={this.pushElement}
                requestSent={this.requestSent}
                lockoutMessage={this.state.lockoutMessage} />;
        } else if (this.state.currentMethod === methodOtp) {
            displayComponent = <AuthyToken method={methodOtp}
                allowRetry={this.allowRetry}
                verificationComplete={this.verificationComplete}
                changeVerificationMethod={this.changeVerificationMethod}
                requestSent={this.requestSent}
                lockoutMessage={this.state.lockoutMessage} />;
        } else if (this.state.currentMethod === methodEmail) {
            displayComponent = <EmailCode method={methodEmail}
                allowRetry={this.allowRetry}
                verificationComplete={this.verificationComplete}
                changeVerificationMethod={this.changeVerificationMethod}
                requestSent={this.requestSent}
                lockoutMessage={this.state.lockoutMessage} />;
        }
        else {
            displayComponent = 
        <div>          
            <div className="mfa-text"> {t("MFA.HowWouldYouLiketoLogin")} </div>
                {renderOneTouch ?
                    <div>
                        <div><LargeButton onClick={() => this.setState({ currentMethod: methodPush, pushSent: false })} id={"oneTouch"}>{t("MFA.MobileAppNotification")}</LargeButton></div>
                        <div><LargeButton onClick={() => this.setState({ currentMethod: methodOtp })} id={"authyToken"}>{t("MFA.MobileAppToken")}</LargeButton></div>
                    </div>
                    : ''}
                {renderEmail ?
                    <div>
                        <div><LargeButton onClick={() => this.setState({ currentMethod: methodEmail })} id={"emailCode"}>{this.state.emailAddress}</LargeButton></div>
                    </div>
                    :''}

            {this.state.phoneNumbers.map(phone =>
                <div key={phone.id}>
                    {phone.type === unknownPhoneType || phone.type === mobilePhoneType ?
                        <div>
                            <LargeButton onClick={() => this.displayPhoneCode(phone.id, methodSms)} id={"smsSendCode_" + phone.id}>{textMsgToTxt}{phone.number}</LargeButton>
                        </div> : ''}

                    <div>
                        <LargeButton onClick={() => this.displayPhoneCode(phone.id, methodVoice)} id={"telSendCode_" + phone.id}>{voiceToTxt}{phone.number}</LargeButton>
                    </div>
                </div>
                )}
                
                <div className="loginMessages highlight">
                    {/*<UnableToSignIn lockoutMessage={this.state.lockoutMessage} />*/}
                    <a className="bottomLink" id="login_back" href={this.state.dayforceLoginUrl}>{t("MFA.BacktoLogin")}</a>
                </div>   
        </div>;
        }

        return (
            <div id="content mfa-text" style={{fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif', paddingTop:30, height:"100vh"}} >
                <div id="loginform"  >
                <img id="topImage" alt={t("Authy.DayforceLogo")} src={CerDFLogo} className="topImage loginImage" />
                    <div className="middle loginMessages">  

                        {hasError ? (<Redirect to="/clientapp/Error" />) : ''}

                        {this.state.showProviderUnavailableModal ? <Modal id="providerUnavailableModal" isOpen="true"
                            title={t("MFA.ProviderUnavailable")}
                            text={t(this.state.providerUnavailableMessage)}
                            closed={this.doVerificationComplete}
                            closeButtonText={t("OK")} /> : ''}

                        {displayComponent}
                    </div>  
                    { /*<Footer dayforceLoginUrl={this.state.returnUrl}/>*/}
                </div>
            </div>
        );
    }
}